import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlockSortAscending: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="block-sort-ascending"><path d="M10.25 3.75H3.75V10.25H10.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10.25 13.75H3.75V20.25H10.25V13.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M18 18V7.5" stroke="currentColor" strokeWidth="1.5"/><path d="M13.75 11.01L18 6.76001L22.25 11.01" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconBlockSortAscending;
